import { ComponentProps, MouseEvent, ReactElement } from 'react';
import { useLinkClickHandler } from 'react-router-dom';

import classNames from 'classnames';

import { Link } from '@spotify-internal/encore-web';

import { useContentNavigationContext } from '../context';

import styles from '../ContentNavigation.module.css';

export type ContentNavigationMenuItemProps = Omit<
  ComponentProps<typeof Link>,
  'href'
> & {
  href: `#${string}`;
};

export const MenuItem = ({
  className,
  href,
  onClick,
  target,
  ...props
}: ContentNavigationMenuItemProps): ReactElement => {
  const { currentSection, goToSection } = useContentNavigationContext();
  const sectionId = decodeURIComponent(href.slice(1));
  const isActive = currentSection === sectionId;
  const handleRouterClick = useLinkClickHandler<Element>(
    { hash: href },
    { target },
  );
  const handleClick = (event: MouseEvent<Element>): void => {
    onClick?.(event);
    if (event.defaultPrevented) return;

    handleRouterClick(event);
    if (event.defaultPrevented) {
      goToSection(sectionId);
    }
  };

  return (
    <Link
      isStandalone
      variant="bodySmall"
      data-track-source-anchor="39ee45cf2b;menu-item-link;low" {...props}
      onClick={handleClick}
      href={href}
      target={target}
      aria-current={isActive ? 'location' : undefined}
      semanticColor={isActive ? 'textBase' : 'textSubdued'}
      className={classNames(styles.menuItem, className)}
    />
  );
};
